import React from "react";
import { Constants } from "../../CommonMethhods/Constants";
import Formfooter from "../../Components/login/FormFooter";
import Formnav from "../../Components/login/FormNav";
import ChangePasswordForm from "./ChangePasswordForm";
import { Link } from "react-router-dom";

function ChangePassword() {
  return (
    <>
      <title>{Constants.Change_Password_Bajaj}</title>
      <div className="login-page">
        <div className="login-content h-100">
          <div className="container h-100">
            <div className="row h-100">
              <div className="ipad-bottom m-auto">
                <ChangePasswordForm fromLogin={true} />

                <Formfooter />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChangePassword;
